import React, { PureComponent } from 'react'
import { mapSelectorsToProps } from 'aria-viewer/core/selectors/mapSelectorsToProps'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'

import {
    AUDIO_TOUR,
    AUDIO_PLAY,
    AUDIO_STOP,
    AUDIO_HS,
    loadAudio,
    playAudio,
    setAudioPlaying,
} from 'aria-viewer/audiomanager/audioManagerActions'

import Browser from 'aria-viewer/utils/mobileDetect'
import QueryParamUtils from 'aria-viewer/utils/queryParamUtils'
import styleguide from 'aria-viewer/tour/constants/styleGuide'
import { isAutoPlayBlocked } from 'aria-viewer/tour/tourActions'
import { SCREEN_SIZES } from 'aria-viewer/tour/constants'
import { HIDE_DRAWER } from 'aria-viewer/drawer/drawerMenuActions'
import { descriptionScrolled, showAvatar, hideAvatar } from 'aria-viewer/guide/avatarActions'
import { MAIN_DESCRIPTION_BOX_INDEX } from 'aria-viewer/keyboard/constants/tabIndices'
import { showDescription } from 'aria-viewer/tour/tourActions'
import compose from 'recompose/compose'

import { AvatarPlayer } from '../../legacy'

const isIPad = Browser.is('ipad'),
    isIPhone = Browser.is('iphone'),
    isPhone = Browser.phone(),
    isMobile = Browser.mobile()

const styleSheet = theme => ({
    largeScreenContainer: {
        width: '15.5em',
        right: 0,
        position: 'absolute',
        zIndex: 5,
    },
    avatarContainerShown: {
        textAlign: 'center',
        display: 'block',
        position: 'relative',
        bottom: '-0.25em',
    },
    avatarContainerHidden: {
        textAlign: 'center',
        display: 'none',
    },
    whitePixelPlatform: {
        display: 'block',
        height: 2,
        background: 'white',
    },
    scrollBarclipContainer: {
        width: '100%',
        height: '100%',
        overflow: 'hidden',
    },
    scrollContainer: {
        width: 'calc(100% + 18px)',
        height: '100%',
        marginRight: '18px',
        overflow: 'auto',
    },
    infoText: {
        fontSize: '1em',
        paddingRight: '18px',
        paddingBottom: '5px',
        '& a': {
            color: 'hsl(240, 100%, 70%)',
        },
    },
    rightInfoText: {
        direction: 'rtl',
        paddingRight: '18px',
        paddingBottom: '12px',
        '& a': {
            color: 'hsl(240, 100%, 70%)',
        },
    },
})

// TODO (1) breakdown "(props)" everywhere
// TODO (2) normalize style (and use JSS)
class Avatar extends PureComponent {
    constructor(props) {
        super(props)

        this.state = {
            hasFinishedPlaying: false,
            isPlaying: false,
            audio_url: false,
            video_url: false,
        }

        this.R = { avatarWrapper: undefined }

        if (!props.useResponsiveUI) {
            this.avatarPlayer = new AvatarPlayer({
                avatarWrapper: this.R.avatarWrapper,
                onFailedToPlay: this.onFailedToPlay,
            })

            const audio = (this.audio = this.avatarPlayer.getAudio())
            if (props.autoplay) audio.oncanplay = this.onCanPlayAudio
            audio.onended = this.onFinishedPlaying
            audio.onplay = this.onPlay

            const video = (this.video = this.avatarPlayer.getVideo())
            if (props.autoplay) video.oncanplay = this.onCanPlayVideo
            video.onended = this.onFinishedPlaying
            video.onpause = this.onPauseVideo
            video.onplay = this.onPlay
        }
    }

    /**
     * Called when play fails, autoplay catch
     */
    onFailedToPlay = media => {
        document.addEventListener(
            'mousedown',
            function() {
                media && media.play()
            },
            { once: true }
        )
    }

    onPlay = () => {
        window[AUDIO_TOUR] = AUDIO_PLAY
        this.props.isAutoPlayBlocked(true)
    }

    onPauseVideo = () => {
        this.avatarPlayer.stopDrawing()
    }

    init = ({
        drawer,
        audioManager,
        allowedAudio,
        tourid,
        location,
        pointInfo,
        pointInfo: { avatar_url, audio_url },
        loadAudio,
        countdown,
        isAvatarMuted,
        toggleDescriptionVisible,
    }) => {
        let clearedState = false
        const canPlay = (allowedAudio == AUDIO_TOUR || !this.state.isPlaying) && !countdown.playingCountdown
        if (
            // when a drawer is showing
            drawer !== HIDE_DRAWER &&
            // our state matches expected
            canPlay == this.state.isPlaying
        ) {
            // Early exiting because there is nothing todo
            return
        }

        if (tourid != this.props.tourid || location != this.props.location || !audio_url) {
            this.setState({ audio_url: false, video_url: false })
            //ensure when switching state the guide doesn't carry over.
            clearedState = true
        }

        if (audioManager.getIn(['state', AUDIO_TOUR]) !== this.props.audioManager.getIn(['state', AUDIO_TOUR])) {
            this.setState({ hasFinishedPlaying: false })
        }

        if (this.props.pointInfo.language.get('display') === pointInfo.language.get('display')) {
            if (this.state.video_url && !clearedState) {
                avatar_url = avatar_url || this.state.video_url
            }
            if (this.state.audio_url && !clearedState) {
                audio_url = audio_url || this.state.audio_url
            }
        } else {
            this.setState({ audio_url: false, video_url: false })
        }

        if (canPlay && avatar_url && !isMobile) {
            this.setState({ isPlaying: true, video_url: avatar_url })

            this.avatarPlayer.pauseAudio()

            if (!this.avatarPlayer.isVideoContainURL(avatar_url)) {
                this.avatarPlayer.setVideoURL(avatar_url)
                loadAudio(AUDIO_TOUR)
            } else {
                if (allowedAudio == AUDIO_TOUR || isPhone)
                    this.onCanPlayVideo({ allowedAudio, toggleDescriptionVisible })
            }
        } else if (canPlay && audio_url) {
            this.setState({ isPlaying: true, audio_url: audio_url })

            this.avatarPlayer.pauseVideo()

            if (!this.avatarPlayer.isAudioContainURL(audio_url)) {
                this.avatarPlayer.setAudioURL(audio_url)
                this.avatarPlayer.loadAudio()
                loadAudio(AUDIO_TOUR)
            } else {
                if (allowedAudio == AUDIO_TOUR || isPhone) this.onCanPlayAudio({ allowedAudio })
            }
        } else {
            this.avatarPlayer.pauseVideo()
            window[AUDIO_TOUR] = AUDIO_STOP
            if (allowedAudio == AUDIO_HS) {
                this.pauseAudioWithFadeOut()
            } else {
                this.avatarPlayer.pauseAudio()
            }
        }

        /*
         * TODO: do not mute in cases where autoplay with volume is expected to work.
         * For example, on Chrome desktop when a sufficient MediaEngagementIndex is attained.
         * See: https://docs.google.com/document/d/1_278v_plodvgtXSgnEJ0yjZJLg14Ogf-ekAFNymAJoU/edit#
         */
        // Pending product signoff
        // if (isAvatarMuted) {
        // 	this.avatarPlayer.muteVideo();
        // 	this.avatarPlayer.muteAudio();
        // } else {
        // 	this.avatarPlayer.unmuteVideo();
        // 	this.avatarPlayer.unmuteAudio();
        // }
    }

    pauseAudioWithFadeOut = () => {
        this.avatarPlayer.fadeAudio(0, 2000, {
            onComplete: () => {
                this.avatarPlayer.pauseAudio()
            },
        })
    }

    componentWillReceiveProps(nextProps) {
        if (this.avatarPlayer) {
            if (nextProps.autoplay && !this.props.autoplay) {
                // Register autoplay
                this.audio.oncanplay = this.onCanPlayAudio
                this.video.oncanplay = this.onCanPlayVideo
            } else if (!nextProps.autoplay && this.props.autoplay) {
                // Deregister autoplay
                this.audio.oncanplay = undefined
                this.video.oncanplay = undefined
            }
            this.init(nextProps)
        }
    }

    componentDidMount() {
        if (this.avatarPlayer) {
            this.avatarPlayer.setWrapper(this.R.avatarWrapper)
            this.init(this.props)
        }
        if (this.props.allowAutoCaption) {
            this.props.showDescription()
        }
    }

    componentWillUnmount() {
        this.timeout && clearTimeout(this.timeout)
        if (this.avatarPlayer) {
            this.avatarPlayer.destroy()
        }
    }

    onCanPlayVideo = ({ allowedAudio, toggleDescriptionVisible }) => {
        if (!this.video) return

        if (toggleDescriptionVisible) {
            hideAvatar()
        } else {
            showAvatar()
        }

        if (!this.state.hasFinishedPlaying && (this.avatarPlayer.canPlayVideo() || Browser.version('Firefox') <= 46)) {
            this.props.playAudio(AUDIO_TOUR)
            this.props.setAudioPlaying(true)
            if (allowedAudio == AUDIO_TOUR) {
                this.avatarPlayer.playVideo()
            }
            this.avatarPlayer.startDrawing()
        }
    }

    onCanPlayAudio = ({ allowedAudio }) => {
        if (
            !this.state.hasFinishedPlaying &&
            (this.avatarPlayer.canPlayAudio() || isIPad || isIPhone || Browser.version('Firefox') <= 46)
        ) {
            let currentVolume = this.avatarPlayer.getAudioVolume()
            if (currentVolume === 0) this.avatarPlayer.setAudioVolume(1)
            this.props.playAudio(AUDIO_TOUR)
            this.props.setAudioPlaying(true)

            if (allowedAudio == AUDIO_TOUR) {
                this.avatarPlayer.playAudio()
            }
        }
    }

    onFinishedPlaying = () => {
        window[AUDIO_TOUR] = AUDIO_STOP
        this.setState({ hasFinishedPlaying: true })
        this.props.setAudioPlaying(false)
        this.props.isAutoPlayBlocked(false)
        this.avatarPlayer.stopDrawing()
    }

    refreshScroll = () => {
        if (this.props.pointInfo.description !== this.prevProps.pointInfo.description && this.R.scrollContainer) {
            this.R.scrollContainer.scrollTop = 0
        }
    }

    handleScroll = () => {
        clearTimeout(this.scrollTimeout)

        this.scrollTimeout = setTimeout(this.props.descriptionScrolled, 300)
    }

    componentDidUpdate(prevProps, prevState) {
        this.prevProps = prevProps
        this.timeout = setTimeout(this.refreshScroll, Number.parseInt(styleguide.delay.fast))
    }

    render() {
        const { toggleDescriptionVisible, currentLanguage, isAvatarShown, useResponsiveUI, classes } = this.props
        const { description } = this.props.pointInfo
        const canPlay = this.props.allowedAudio == AUDIO_TOUR
        const hasAvatar =
            this.state.video_url &&
            this.video.src &&
            this.props.height - 400 > 150 &&
            canPlay &&
            !this.state.hasFinishedPlaying

        // Arabic, Hebrew, Urdu, Persian read from right to left
        const rightLanguages = ['Arabic', 'Hebrew', 'Urdu', 'Persian']
        let isRightLanguage = rightLanguages.includes(currentLanguage)

        const hasDescription = description && toggleDescriptionVisible
        const largeScreen = this.props.width >= SCREEN_SIZES.size_1350
        return (
            <div className={largeScreen ? classes.container : classes.largeScreenContainer}>
                {!useResponsiveUI && (
                    <div
                        id="avatar"
                        className={
                            hasAvatar && isAvatarShown ? classes.avatarContainerShown : classes.avatarContainerHidden
                        }
                    >
                        <div ref={c => (this.R.avatarWrapper = c)} />
                    </div>
                )}
                <div
                    style={{
                        background: 'rgba(8,19,30,.85)',
                        padding: hasDescription
                            ? largeScreen
                                ? '1em 0.48125em 0 .875em'
                                : '0.875em 0.35625em 0.9375em 0.8125em'
                            : '0 0.48125em 0 1em',
                        color: 'white',
                        height: hasDescription ? (hasAvatar ? (largeScreen ? '13vh' : '10vh') : '18vh') : 0,
                        transition: `height ${styleguide.delay.fast}, padding ${styleguide.delay.fast}`,
                    }}
                >
                    <div
                        className="info requiresKeyboardControl"
                        style={{
                            height: hasDescription ? (hasAvatar ? (largeScreen ? '13vh' : '10vh') : '18vh') : 0,
                            transition: `height ${styleguide.delay.fast}`,
                        }}
                        tabIndex={MAIN_DESCRIPTION_BOX_INDEX}
                    >
                        <div className={classes.scrollBarclipContainer}>
                            <div
                                className={classes.scrollContainer}
                                onScroll={this.handleScroll}
                                ref={c => (this.R.scrollContainer = c)}
                            >
                                <div
                                    id="scene-description"
                                    className={isRightLanguage ? classes.rightInfoText : classes.infoText}
                                    dangerouslySetInnerHTML={{ __html: description }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {(hasDescription || hasAvatar) && <div className={classes.whitePixelPlatform} />}
            </div>
        )
    }
}

const mapStateToProps = state => ({
    currentLanguage: state.getIn(['language', 'current', 'language']),
    autoplay: state.getIn(['audioManager', 'autoplay']),
    isAvatarShown: state.getIn(['avatar', 'isAvatarShown']),
    countdown: state.getIn(['countdown']),
    allowAutoCaption: QueryParamUtils.isQueryValuePresentAndEqual('vt-auto-caption', 'true', 'false'),
})

export default compose(
    injectSheet(styleSheet),
    connect(mapStateToProps),
    connect(
        mapSelectorsToProps([
            'drawer',
            'tourid',
            'location',
            'pointInfo',
            'audioManager',
            'toggleDescriptionVisible',
            'allowedAudio',
            'platform',
            'isAvatarMuted',
        ]),
        {
            isAutoPlayBlocked,
            playAudio,
            loadAudio,
            setAudioPlaying,
            descriptionScrolled,
            showDescription,
            hideAvatar,
            showAvatar,
        }
    )
)(Avatar)
